import SponsorController from './sponsor.controller.js';
import SponsorUpdateController from './sponsor-update.controller.js';

// Import html templates
import './partials/sponsor-form.html';
import './partials/sponsor-overlap.html';
import './sponsor-results.html';
import './sponsor-results.html';
import './sponsor-availability.html';
import sponsorsTpl from './sponsors.html';
import sponsorsAddTpl from './sponsor.update.html';
import sponsorsEditTpl from './sponsor.update.html';

export default function sponsorsRouter($stateProvider) {
  $stateProvider
    .state('app.sponsors', {
      url: '/sponsors',
      templateUrl: sponsorsTpl,
      controller: SponsorController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['SPONSOR_READ'],
      },
    })
    .state('app.sponsors.add', {
      url: '/add',
      templateUrl: sponsorsAddTpl,
      controller: SponsorUpdateController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['SPONSOR_CREATE'],
      },
    })
    .state('app.sponsors.edit', {
      url: '/:sponsorId/edit',
      templateUrl: sponsorsEditTpl,
      controller: SponsorUpdateController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['SPONSOR_UPDATE'],
      },
    });
}



// WEBPACK FOOTER //
// ./src/app/sponsors/sponsors.router.js